import type { Ref } from 'vue';
import { ref, watch } from 'vue';
import type {
  DialogEmits,
  DialogProps,
} from '@/common/components/zvdzo/BaseDialog.types';

export default function useDialogIsOpen(
  props: DialogProps,
  emit: DialogEmits,
): Ref<boolean> {
  const booleanIsOpen = ref<boolean>(props.isOpen || false);

  watch(booleanIsOpen, (v?: boolean) => {
    emit('update:is-open', Boolean(v));
    if (!v) {
      emit('close');
    }
  });

  watch(
    () => props.isOpen,
    (v?: boolean) => {
      booleanIsOpen.value = v || false;
    },
  );

  return booleanIsOpen;
}
